function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Button from "../components/button/button";
import LoadingIndicator from "../loading-indicator/loading-indicator";

var LoadingButton = function LoadingButton(props) {
  var loading = props.loading,
      rest = _objectWithoutProperties(props, ["loading"]); // eslint-disable-next-line prefer-const


  var disabled = rest.disabled,
      buttonProps = _objectWithoutProperties(rest, ["disabled"]);

  var visibility = 'visible';

  if (loading) {
    visibility = 'hidden';
    disabled = true;
  }

  return React.createElement(Button, _extends({}, buttonProps, {
    disabled: disabled
  }), loading && React.createElement(LoadingIndicator, {
    small: true,
    top: 7
  }), React.createElement("span", {
    style: {
      visibility: visibility
    }
  }, props.children));
};

LoadingButton.displayName = 'LoadingButton';
LoadingButton.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool
};
export default LoadingButton;